import { isMobile } from '@growtherapy/analytics';

import { isSafari as isBrowserSafari } from '../../utils';
import { BlockedPermissionsActionItem } from './BlockedPermissionsActionItem';

export function BlockedPermissionsActionItemWrapper() {
  const isMobileDevice = isMobile(navigator.userAgent);
  const isSafari = isBrowserSafari();
  return <BlockedPermissionsActionItem isMobile={isMobileDevice} isSafari={isSafari} />;
}
